/**
 * The admin panel's wiring for `@ponder/artifacts/agent-avatar`
 * (docs/avatar-integration-spec.md §2.3, P4 admin). Agent list rows carry the
 * resolved ref with its static `svg`, so they paint without a fetch; these
 * fetchers only cover a row without one. The package's store dedupes and
 * memoises, so each avatar is fetched at most once per session.
 */
import type { AgentAvatarHost } from '@ponder/artifacts/agent-avatar'
import type { AvatarData } from '@ponder/artifacts/avatar-engine'
import { avatarApi } from './api'

export const adminAgentAvatarHost: AgentAvatarHost = {
  async fetchAvatarArtifact(artifactId) {
    const artifact = await avatarApi.getAvatarArtifact(artifactId)
    if (!artifact || artifact.type !== 'Avatar') return null
    const data = artifact.data as AvatarData | undefined
    if (!data || !Array.isArray(data.strokes)) return null
    return { data, version: artifact.version }
  },

  resolveAgentAvatar: (agentId) => avatarApi.getAgentAvatar(agentId),
}
